export function shortenText(text: string, size: number) {
  if(!text) {
    return text;
  }
  if(text.length < size) {
    return text;
  }
  return `${text.slice(0,size)} ...`;
}